import React, { useState } from "react";

import { isMobile, isTablet, isDesktop } from "react-device-detect";
import { Grid, TextField, Link, Button, CircularProgress } from "@mui/material";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import useStyles from "./Login.style";
import { loginStart } from "../../redux-saga/redux/auth/authentication";

const Login = ({ handleCloseLogin, style }) => {
  const defaultClasses = useStyles();
  const classes = style ? style : defaultClasses;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [show, setShow] = useState(false);
  const [userNameOrEmail, setUserNameOrEmail] = useState("");
  const [password, setPassword] = useState("");

  const { loading, metamaskLoading } = useSelector(
    (state) => state.authentication
  );
  const deviceType = isTablet
    ? "Tablet"
    : isMobile
      ? "Mobile"
      : isDesktop
        ? "Desktop"
        : null;

  const handleLoginAuth = (e) => {
    e.preventDefault();
    const validation = [];
    if (userNameOrEmail.length === 0) {
      validation.push(t("COMMON.EMAIL_EMPTY"));
    } else if (!userNameOrEmail || !userNameOrEmail.trim()) {
      validation.push(t("HEADER.USERNAME_EMAIL_ERROR_MSG"));
    }
    if (password.trim().length === 0) {
      validation.push(t("COMMON.PASSWORD_EMPTY"));
    }
    if (validation.length !== 0) {
      let msg = "";
      validation.forEach((message) => {
        msg = msg ? `${msg}, \n${message}` : `${message}`;
      });
      toast.error(msg.replace(".", ""), {
        id: msg
      });
      return;
    }

    dispatch(
      loginStart({
        userNameOrEmail: userNameOrEmail?.trim(),
        password: window.btoa(password?.trim()),
        deviceType: deviceType
      })
    );
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleEmail = (e) => {
    setUserNameOrEmail(e.target.value);
  };

  const handleShow = (e) => {
    e.preventDefault();
    setShow((prevState) => !prevState);
  };

  return (
    <Grid className={classes.loginContainer}>
      <Grid className={classes.loginFormWrap}>
        <form>
          <Grid className={classes.formGroup}>
            <TextField
              type="userNameOrEmail"
              id="userNameOrEmail"
              placeholder={t("HEADER.USERNAME_EMAIL")}
              variant="outlined"
              onChange={handleEmail}
            />
          </Grid>
          <Grid className={classes.formGroup}>
            <TextField
              type={show ? "text" : "password"}
              id="pwd"
              placeholder={t("COMMON.PASSWORD")}
              variant="outlined"
              onChange={handlePassword}
            />
            <Link href="#" className={classes.showLink} onClick={handleShow}>
              {!show ? t("COMMON.SHOW") : t("COMMON.HIDE")}
            </Link>
          </Grid>
          <Grid className={classes.authBtnWrap}>
            <Button
              type="submit"
              className={classes.btnPrimary}
              onClick={handleLoginAuth}
              disabled={loading || metamaskLoading}
            >
              {loading ? (
                <CircularProgress size="1.5rem" />
              ) : (
                t("HEADER.LOG_IN")
              )}
            </Button>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default Login;
